import LabelWeex from "./LabelWeex";
import {useState} from "react";
import {ElementStyles} from "./ElementStyles";

export default function ButtonWeex({children, onClick= null, selected = false, style = null, arrow = null, ...props}){
  const [mouseDown, setMouseDown] = useState(false)

  const styles = {
    button:{
      cursor: "pointer",
      boxShadow: mouseDown? "0px 0px 5px gray" :
        selected ? "0px 0px 5px 3px blue" :
          ""
    },
    container: {
      borderRadius: ElementStyles.borderRadius,
      boxSizing: "inherit",
      background: ElementStyles.background,
      color: ElementStyles.color,
      padding: ElementStyles.paddingLabels,
      minHeight: ElementStyles.height,
      display: "flex",
      alignItems: "center"
    }
  }

  return (
    <div
      onMouseDown={()=>setMouseDown(true)}
      onTouchStart={()=>setMouseDown(true)}
      onTouchEnd={()=>setMouseDown(false)}
      onDragLeave={()=>setMouseDown(false)}
      onMouseLeave={()=>setMouseDown(false)}
      onMouseUp={()=>setMouseDown(false)}
      onClick={onClick}
      {...props}
      style={{...styles.container, ...styles.button, ...style}}
    >
      <LabelWeex style={style}>
        {children}
      </LabelWeex>
      <div style={{width: "100%"}}/>
      {arrow && <div style={{}}>{">"}</div>}
    </div>
  );
};

